import { useState } from 'react'
import { Link } from 'react-router-dom'
import { ComingSoonBanner } from '../components/Alert'
import { EmptyState } from '../components/States'

const SOURCES: Array<[string, string]> = [
  ['Upload', 'Drag files in'],
  ['Email in', 'A per-tenant inbox address'],
  ['Watched folder', 'Local agent'],
  ['Mobile capture', 'Scan a QR to use your phone'],
]

export function ReceiptsPage() {
  const [source, setSource] = useState(SOURCES[0][0])

  return (
    <div className="wrap">
      <div className="phead">
        <div>
          <div className="crumb">
            <Link to="/app">Home</Link> / Receipts
          </div>
          <h2>Receipts</h2>
          <p className="fs13 muted" style={{ margin: '6px 0 0' }}>
            Drop photos or PDFs of receipts. We read them, you confirm, we post the expense.
          </p>
        </div>
        <span className="spacer" />
        <span className="tagp t-p1">P1</span>
        <span className="pill">50 credits per file</span>
      </div>

      <ComingSoonBanner feature="Receipt OCR" />

      <div className="srcs" style={{ marginBottom: 18 }}>
        {SOURCES.map(([name, hint]) => (
          <div
            className={source === name ? 'src on' : 'src'}
            key={name}
            onClick={() => setSource(name)}
          >
            <b>{name}</b>
            <span className="fs12 faint" style={{ display: 'block', marginTop: 4 }}>
              {hint}
            </span>
          </div>
        ))}
      </div>

      <div className="card">
        <div className="card-h">
          <h3>Queue</h3>
          <span className="spacer" />
          <span className="fs12 faint">0 waiting for review</span>
        </div>
        <EmptyState
          icon="🧾"
          title="No receipts yet"
          body="OCR runs through a document-processing endpoint that is not in the current API. Uploaded files, their read confidence and the review panel will appear here."
        />
      </div>
    </div>
  )
}
